import { render, staticRenderFns } from "./BasicOverviewCompany.vue?vue&type=template&id=5bfa5e01"
import script from "./BasicOverviewCompany.vue?vue&type=script&lang=js"
export * from "./BasicOverviewCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports